import React, { useEffect } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { ThemePallete } from 'components/ThemePallete/ThemePallete';
import { THEME_DESCRIPTION_KEYS, THEME_KEYS, THEME_NAME_KEYS, themeColors, ThemeKey } from 'config';
import { Thumbnail } from '@wix/design-system';
import styles from './ThemeContent.scss';
import { useAppStore } from 'stores/appStore';
import { biLogger, useProtectedNavigation } from 'hooks';
import { BI_CONSTANTS } from 'hooks/biLogger/biConstants';
import { StepId } from 'config/steps';

export function ThemeContent() {
  const { t } = useTranslation();
  // Login gate for the flow - guards navigation from Theme → SetupStore
  const handleContinue = useProtectedNavigation({ returnToStepId: StepId.Theme });

  const selectedThemeKey = useAppStore((state) => state.selectedThemeKey);
  const setSelectedThemeKey = useAppStore((state) => state.setSelectedThemeKey);

  useEffect(() => {
    if (!selectedThemeKey) {
      setSelectedThemeKey(THEME_KEYS.RECOMMENDED);
    }
  }, [selectedThemeKey, setSelectedThemeKey]);

  const handleThemeClick = (themeKey: ThemeKey) => {
    biLogger.actionClicked({
      action: BI_CONSTANTS.ACTION.THEME_SELECTED,
      button_name: BI_CONSTANTS.BUTTON_NAME.SELECT,
      value: themeKey,
    });

    setSelectedThemeKey(themeKey);
  };

  return (
    <StepLayout
      title={t('template.heading')}
      description={t('template.description')}
      nextButtonProps={{
        label: t('template.cta'),
      }}
      overrideNext={() => handleContinue()}
    >
      {themeColors.map((theme) => (
        <Thumbnail
          key={theme.name}
          onClick={() => handleThemeClick(theme.name)}
          selected={selectedThemeKey === theme.name}
        >
          <div className={styles.themeThumbnail}>
            <ThemePallete
              title={t(THEME_NAME_KEYS[theme.name])}
              description={t(THEME_DESCRIPTION_KEYS[theme.name])}
              colors={theme.colors}
            />
          </div>
        </Thumbnail>
      ))}
    </StepLayout>
  );
}
